function supply_station(){
	var data = ajax_call(publicPath + "/napi/device/supplystation")
	var layer = L.geoJson(data, {
		pointToLayer: function(feature, latlng) {
			return L.marker(latlng, {
					icon: new L.DivIcon({ html: '<div><span>' + feature.properties.count + '</span></div>', className: 'marker-cluster-ma-0' + ' marker-cluster-small_blue', iconSize: new L.Point(20, 20) })
			}).bindPopup('<div id="popup_div" class="w-300">資料連結中...</div>');
		}
	}).on('click', function(e){
		var this_marker = e.layer.feature.properties
		setTimeout(function(){
			$('#popup_div').html(
				'<h5>救災物資配送站</h5>' + 
				'<h6>行政區：' + this_marker.area + '</h6>' +
				'<h6>地址：' + this_marker.address + '</h6>' +
				'<h6>數量：' + this_marker.count + '</h6>' +
				'<h6>村里：' + this_marker.village + '</h6>' +
				'<h6>服務人數：' + this_marker.service_people + '</h6>'
			)			
		}, 1000);
	})
	return layer
}

function refuge_swd(){
	var geo_json = new geoJsonTemplate(),
		data = ajax_call(publicPath + "/napi/device/reguge/status");
	data.forEach(function(element){
		if (element.lon && element.lat) {
			geo_json.features.push({
				"type": "Feature",
				"geometry": {
					  "type": "Point",
					  "coordinates": [parseFloat(element.lon), parseFloat(element.lat)]
				},
				"properties": element
			})
		}
	})
	var refuge_layer = L.geoJSON(geo_json,{
      	pointToLayer: function(feature, latlng) {
			var iconUrl = 'marker_icon/refuge_g.png'
			if (feature.properties.open_status == '開啟') {
				iconUrl = 'marker_icon/refuge_r.png'
			}
        	return L.marker(latlng, {
          		icon: new L.icon({
					iconUrl: iconUrl,
					iconAnchor:   [15, 30],
					iconSize:     [30, 30],
					popupAnchor:  [0, -20]
				})
        	}).bindPopup('<div id="refuge_area" class="w-300">資料讀取中...</div>');
      	}
    }).on('click', onClick);
    function onClick(e) {
		var this_marker = e.layer.feature.properties
		setTimeout(function(){
			$('#refuge_area').html(
				'<h5>' + this_marker.name + '</h5>' + 
				'<h6>開設狀態：' + this_marker.open_status + '</h6>' +
				'<h6>地址：' + this_marker.address + '</h6>' + 
				'<h6>聯絡電話：' + this_marker.contact_phone + '</h6>' + 
				'<h6>目前志工人數：' + this_marker.volunteer_number + '人</h6>' + 
				'<h6>目前收容人數：' + this_marker.refugee_number.total + '人 (男' + this_marker.refugee_number.male + '/女' + this_marker.refugee_number.female + ')' + '</h6>' + 
				'<h6>最大容納人數：' + this_marker.accept_population + '</h6>' + 
				'<h6>適用災害：' + this_marker.disaster_type + '</h6>' + 
				'<h6>適於弱勢：' + this_marker.adapt_for_weaker + '</h6>' +
				'<h6>室內/室外：' + this_marker.is_indoor + '/' + this_marker.is_outdoor + '</h6>' +
				'<h6>收容村里：' + this_marker.default_village + '</h6>'
			)			
		}, 1000);
	}
	return refuge_layer;
}

function important_bridge() {
	var geo_json = new geoJsonTemplate(),
		data = ajax_call("geojson/earthquake/important_bridge.json");
		
	data.forEach(function(element){
		if (element.y && element.x) {
			geo_json.features.push({
				"type": "Feature",
				"geometry": {
					  "type": "Point",
					  "coordinates": [element.x, element.y]
				},
				"properties": element
			})
		}
	})

	var important_bridge_layer = L.geoJSON(geo_json,{
		pointToLayer: function(feature, latlng) {
		  	return L.marker(latlng, {
				icon: new L.icon({
				  iconUrl: 'marker_icon/bridge.png',
				  iconAnchor:   [15, 30],
				  iconSize:     [30, 30],
				  popupAnchor:  [0, -20]
			  	})
		  	}).bindPopup('<div id="important_bridge" class="w-300">資料讀取中...</div>');
		}
  	}).on('click', onClick);
	
	function onClick(e) {
		var this_marker = e.layer.feature.properties
		let built_year_month = ''
		if (this_marker.built_y > 0 && this_marker.built_m > 0) {
			built_year_month = `民國 ${this_marker.built_y} 年 ${this_marker.built_m} 月`
		} else if (this_marker.built_y > 0 && this_marker.built_m <= 0) {
			built_year_month = `民國 ${this_marker.built_y} 年`
		} else {
			built_year_month = ' - '
		}
		setTimeout(function(){
			$('#important_bridge').html(
				'<h5>' + this_marker.bridge_name + '</h5>' + 
				'<h6>隸屬行政區：' + this_marker.town + '</h6>' + 
				'<h6>河流名稱：' + this_marker.river_name + '</h6>' + 
				'<h6>橋梁長度：' + this_marker.total_length + ' 公尺</h6>' + 
				'<h6>橋梁類型：' + this_marker.structure + '</h6>' +
				'<h6>橋梁現況：' + this_marker.use_status + '</h6>' +
				'<h6>建造年月：' + built_year_month + '</h6>'
			)			
		}, 1000);
	}
	return important_bridge_layer;
}

function pump_wrs(target = '') {
	var result = null, 
		pump_realtime_data,
		Icon_setting = {
			iconUrl: '',
			iconAnchor:   [16, 32],
			iconSize:     [32, 32],
			popupAnchor:  [0, -20]
		},
		geojson_data = new geoJsonTemplate()
		pump_realtime_data = raw_data["抽水站"] ? raw_data["抽水站"] : ajax_call(publicPath + "/napi/obs/pumpstatus");
	pump_realtime_data.forEach(function(data){
		geojson_data.features.push({
			"type": "Feature",
			"geometry": {
				"type": "Point",
				"coordinates": [parseFloat(data.lon_wgs84), parseFloat(data.lat_wgs84)]
			},
			"properties": {
				"NAME_C": data.name_zh,
				"ADDR_C": data.address_zh,
				"ST_NO": data.station_no,
				"PUMP_MANAGER_NAME": data.PUMP_MANAGER_NAME,
				"PUMP_TEL": data.PUMP_TEL,
				"PUMP_MANAGER_CELL": data.PUMP_MANAGER_CELL,
				"TOWN_NAME": data.town_name,
				"Date": data.time,
				"Status": data.status
			}
		})
	})
	var pump_layer = L.geoJSON(geojson_data, {
      	pointToLayer: function(feature, latlng) {
      		var status_string = feature.properties.Status;
      		var logical_statement = pump_status_true(status_string);
      		if (logical_statement == "開啟") {
      			Icon_setting['iconUrl'] = 'marker_icon/pump_r.png';
      		} else {
      			Icon_setting['iconUrl'] = 'marker_icon/pump_g.png';
      		}
      		var pump_Icon = new L.icon(Icon_setting)
        	return L.marker(latlng, {
          		icon: pump_Icon
        	}).bindPopup('<div id="pump_area" class="w-250">資料連結中...</div>');
      	},
		filter: (feature, layer) => {
			switch (target) {
				case '運轉中':
					return pump_status_true(feature.properties.Status) == '開啟'
				case '待命中':
					return pump_status_true(feature.properties.Status) == '停止'
				case '離線':
					return pump_status_true(feature.properties.Status) == '離線'
				default:
					return feature
			}
		}
    });
    pump_layer.on('click', onClick);

    result = [pump_layer, pump_realtime_data];
    function onClick(e) {
    	var this_marker = e.layer.feature.properties;
		setTimeout(function(){
			$('#pump_area').html(
				'<h5>' + this_marker.NAME_C + '抽水站</h5>' + 
				'<h6>時間：' + this_marker.Date.slice(0,16) + '</h6>' +
				'<h6>地址：' + this_marker.ADDR_C + '</h6>' +
				'<h6>抽水：' + pump_status_true(this_marker.Status) + '</h6>'+
				'<h6>聯絡電話：' + null_Converter_v2(this_marker.PUMP_TEL) + '</h6>'
			)			
		}, 1000);
    }
	return result;
}

function moving_car_wrs(target = ''){
	var result = null, car_ntc;
	var Icon_Setting = {
	    iconUrl: '',
	    iconAnchor:   [16, 32],
	    iconSize:     [32, 32],
	    popupAnchor:  [0, -20]
	};
	var geojson_data = {
	  	type: "FeatureCollection",
	  	features: []
	};
	raw_data["移動抽水機"] ? ( (car_ntc = raw_data["移動抽水機"]) ) : ( (car_ntc = ajax_call(publicPath + "/napi/obs/pumpmoving")));
	car_ntc.forEach(function(element){
		geojson_data.features.push({
			"type": "Feature",
			"geometry": {
		      	"type": "Point",
		      	"coordinates": [parseFloat(element._lon), parseFloat(element._lat)]
			},
			"properties": {
				"ID": element._id,
				"Status": element._status,
				"ROAD": element._road,
				"TIME": element.operateat
			}
		});
	});
	var car_ntc_layer = L.geoJSON(geojson_data, {
      	pointToLayer: function(feature, latlng) {
      		if (feature.properties.Status == "抽水中") {
      			Icon_Setting["iconUrl"] = 'marker_icon/pump_car_r.png';
      		} else if(feature.properties.Status == "待命") {
      			Icon_Setting["iconUrl"] = 'marker_icon/pump_car_g.png';
      		} else if(feature.properties.Status == "運送中") {
      			Icon_Setting["iconUrl"] = 'marker_icon/pump_car_b.png';
      		} else if(feature.properties.Status == "離線") {
      			Icon_Setting["iconUrl"] = 'marker_icon/pump_car_y.png';
      		} else {
      			Icon_Setting["iconUrl"] = 'marker_icon/pump_car_grey.png';
      		}
      		var pump_Icon = new L.icon(Icon_Setting);
        	return L.marker(latlng, {
          		icon: pump_Icon
        	}).bindPopup('<div id="other_area" class="w-250">資料連結中...</div>');
      	},
		filter: (feature, layer) => {
			switch (target) {
				case "抽水中":
					return feature.properties.Status == "抽水中"
				case "待命":
					return feature.properties.Status == "待命"
				case "運送中":
					return feature.properties.Status == "運送中"
				case "離線":
					return feature.properties.Status == "離線"
				case "故障":
					return feature.properties.Status == "故障"
				case "其他":
					return feature.properties.Status == "其他"
				default:
					return feature
			}
		}
    })
    car_ntc_layer.on('click', onClick);
    result = [car_ntc_layer, car_ntc];
    function onClick(e) {
    	var this_marker = e.layer.feature.properties;
		setTimeout(function(){
			$('#other_area').html(
				'<h5>' + this_marker.ID + '移動抽水機</h5>' + 
				'<h6>時間：' + this_marker.TIME.slice(0,16) + '</h6>' +
				'<h6>狀態：' + this_marker.Status + '</h6>' +
				'<h6>道路：' + this_marker.ROAD + '</h6>'
			)			
		}, 1000);
    }
	return result;
}

function waterdoor_status(target = ''){
	var geo_json = {type: "FeatureCollection", features: []}, data = [];
	var Icon_Setting = {
	    iconUrl: '',
	    iconAnchor:   [16, 32],
	    iconSize:     [32, 32],
	    popupAnchor:  [0, -20]
	};
	raw_data["橫移門"] ? ( (data = raw_data["橫移門"]) ) : ( (data = ajax_call(publicPath + "/napi/obs/othergate")));
	var data_basic = raw_data["wrs_gate_basic"], name, number_gate, address, status, coor_x, coor_y;
	try {
		data.forEach(function(element){
			if (element.Gate_No.slice(0,1) == "G") {
				for (var item in data_basic) {
					if (element.Gate_No == data_basic[item].Gate_No) {
						name = data_basic[item].NAME_C;
						number_gate = data_basic[item].Gate_No;
						address = data_basic[item].ADDR_C;
						coor_x = data_basic[item].LON_DEC;
						coor_y = data_basic[item].LAT_DEC;
					}
				}
				if (element.Gate_No == "G15") {
					var string_raw = element.OpenClose.split("|");
					if (string_raw[0] == "0") {
						status = "關閉";
					} else{
						status = "開啟";
					}
				} else {
					switch(element.OpenClose){
						case "1":
							status = "開啟";
							break;
						case "0":
							status = "關閉";
							break;
					}
				}
				geo_json.features.push({
					"type": "Feature",
					"geometry": {
						  "type": "Point",
						  "coordinates": [coor_x, coor_y]
					},
					"properties": {
						"Name": name + "(" + element.Gate_No + ")",
						"Time": element.Date,
						"Address": address,
						"Status": status
					}
				})
			}		
		})
	} catch (e) {
		toast_open("橫移門狀態介接異常！")
	}
	var waterdoor_layer = L.geoJSON(geo_json, {
      	pointToLayer: function(feature, latlng) {
      		if (feature.properties.Status == "開啟") {
      			Icon_Setting["iconUrl"] = 'marker_icon/gate_g.png';
      		} else {
      			Icon_Setting["iconUrl"] = 'marker_icon/gate_r.png';
      		}
        	return L.marker(latlng, {
          		icon: new L.icon(Icon_Setting)
        	}).bindPopup('<div id="other_area" class="w-250">資料連結中...</div>');
      	},
		filter: (feature, layer) => {
			switch (target) {
				case '開啟':
					return feature.properties.Status == '開啟'
				case '關閉':
					return feature.properties.Status == '關閉'
				case '離線':
					return feature.properties.Status == '離線'
				default:
					return feature
			}
		}
    });
    waterdoor_layer.on('click', onClick);
    function onClick(e) {
    	var this_marker = e.layer.feature.properties;
		setTimeout(function(){
			$('#other_area').html(
				'<h5>' + this_marker.Name + '橫移門</h5>' + 
				'<h6>狀態：' + this_marker.Status + '</h6>'+
				'<h6>時間：' + this_marker.Time.slice(0,16) + '</h6>'+
				'<h6>地址：' + this_marker.Address + '</h6>'
			)			
		}, 1000);
    }
    var result = [waterdoor_layer, data];
    return result;
}

function reservior_status(){
	var Icon_Setting = {
	    iconUrl: '',
	    iconAnchor:   [16, 32],
	    iconSize:     [32, 32],
	    popupAnchor:  [0, -20]
	};
	var reservior_object = {}, reservior_data, reseviorCapacityRate = ajax_call(publicPath + "/napi/obs/reservior")
	raw_data["重要水庫"] ? ( (reservior_data = raw_data["重要水庫"]) ) : ( (reservior_data = ajax_call(publicPath + "/napi/obs/reserviorobs")));
	reservior_data.forEach(function(element){
		reservior_object[element.reservoir_identifier] = element;
	});
	var geo_json = 
		{ type: "FeatureCollection",
		  features: [{
				"type": "Feature",
				"geometry": {
			      	"type": "Point",
			      	"coordinates": [121.246052, 24.811043]
				},
				"properties": {
					"name": "石門水庫",
					"time": reservior_object["10201"].time,
					"status": condition_reservior_status(reservior_object["10201"].status_type),
					"cms": null_Converter_v2(reservior_object["10201"].total_outflow),
					"EffectiveWaterStorageCapacity": parseFloat(reservior_object["10201"].effective_water_storage_capacity).toFixed(2),
					"WaterLevel": parseFloat(reservior_object["10201"].water_level).toFixed(2),
					"FullWaterLevel": reseviorCapacityRate["石門水庫"]["LEVEL_FULL"],
					"CapacityRate": reseviorCapacityRate["石門水庫"]["CapacityRate"]
				}
			}, {
				"type": "Feature",
				"geometry": {
			      	"type": "Point",
			      	"coordinates": [121.579968, 24.909105]
				},
				"properties": {
					"name": "翡翠水庫",
					"time": reservior_object["10205"].time,
					"status": condition_reservior_status(reservior_object["10205"].status_type),
					"cms": null_Converter_v2(reservior_object["10205"].total_outflow),
					"EffectiveWaterStorageCapacity": parseFloat(reservior_object["10205"].effective_water_storage_capacity).toFixed(2),
					"WaterLevel": parseFloat(reservior_object["10205"].water_level).toFixed(2),
					"FullWaterLevel": reseviorCapacityRate["翡翠水庫"]["LEVEL_FULL"],
					"CapacityRate": reseviorCapacityRate["翡翠水庫"]["CapacityRate"]
				}
			}]
		};
	var reservior_layer = L.geoJSON(geo_json, {
      	pointToLayer: function(feature, latlng) {
      		if (feature.properties.status == "無洩洪") {
      			Icon_Setting["iconUrl"] = 'marker_icon/dam_g.png';
      		} else {
      			Icon_Setting["iconUrl"] = 'marker_icon/dam_r.png';
      		}
        	return L.marker(latlng, {
          		icon: new L.icon(Icon_Setting)
        	}).bindPopup('<div id="other_area" class="w-250">資料連結中...</div>');
      	}
    });
    reservior_layer.on('click', onClick);
    function onClick(e) {
		var this_marker = e.layer.feature.properties, this_cms = '-'
		if (this_marker.cms != '-') {
			this_cms = parseFloat(this_marker.cms).toFixed(2)
		}
		setTimeout(function(){
			$('#other_area').html(
				'<h5>' + this_marker.name + '</h5>' + 
				'<h6>狀態：' + this_marker.status + '</h6>'+
				'<h6>時間：' + this_marker.time.slice(0,16) + '</h6>'+
				'<h6>流量：' + this_cms + 'cms</h6>'+
				'<h6>有效蓄水容量：' + this_marker.EffectiveWaterStorageCapacity + '立方公尺</h6>'+
				'<h6>有效蓄水率：' + this_marker.CapacityRate + '</h6>' +
				'<h6>水位高：' + this_marker.WaterLevel + 'm</h6>' +
				'<h6>滿水位：' + this_marker.FullWaterLevel + 'm</h6>'
			)			
		}, 1000);
    }
    var result = reservior_layer;
    return result;
}

function diviflow_status(){
	var Icon_Setting = {
	    iconUrl: '',
	    iconAnchor:   [16, 32],
	    iconSize:     [32, 32],
	    popupAnchor:  [0, -20]
	}, data;
	raw_data["員山子分洪"] ? ( (data = raw_data["員山子分洪"]) ) : ( (data = ajax_call(publicPath + "/napi/obs/kyzobs")));
	var geo_json = 
		{ type: "FeatureCollection",
		  features: [{
				"type": "Feature",
				"geometry": {
			      	"type": "Point",
			      	"coordinates": [121.829951, 25.106119]
				}, 
				"properties": {
					"name": "員山子分洪道",
					"time": data[0].time,
					"divi_flow": data[0].divi_flow
				}
			}]
		};
	var diviflow_layer = L.geoJSON(geo_json, {
      	pointToLayer: function(feature, latlng) {
      		if (feature.properties.divi_flow <= 0) {
      			Icon_Setting["iconUrl"] = 'marker_icon/dam_g.png';
      		} else {
      			Icon_Setting["iconUrl"] = 'marker_icon/dam_r.png';
      		}
        	return L.marker(latlng, {
          		icon: new L.icon(Icon_Setting)
        	}).bindPopup('<div id="other_area" class="w-250">資料連結中...</div>');
      	}
    });
    diviflow_layer.on('click', onClick);
    function onClick(e) {
    	var this_marker = e.layer.feature.properties;
		setTimeout(function(){
			$('#other_area').html(
				'<h5>' + this_marker.name + '</h5>' + 
				'<h6>時間：' + this_marker.time.slice(0,16) + '</h6>'+
				'<h6>分洪流量：' + this_marker.divi_flow + 'cms</h6>'
			)			
		}, 1000);
    }
    var result = diviflow_layer;
    return result;	
}
